<script>
    export default {
        name: "TheModalWrap",
        props: {
            title: String,
            subTitle: String,
        },
    };
</script>

<template>
    <div class="base-popup-wrap">
        <div class="base-popup-wrap__title">{{ title }}</div>
        <div v-if="subTitle" class="base-popup-wrap__subtitle">{{ subTitle }}</div>
        <div class="base-popup-wrap__content">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss">
    .base-popup-wrap__title {
        margin-bottom: 24px;
        padding-right: 10px;
        font-family: var(--modal-heading-font);
        font-size: var(--modal-heading-size);
        font-weight: var(--modal-heading-weight);
        text-transform: var(--modal-heading-case);
    }

    .base-popup-wrap__subtitle {
        margin-bottom: 8px;
        font-size: 16px;
        line-height: 24px;
    }

    .base-popup-wrap__content {
        margin-bottom: 10px;
    }
</style>
